import { __ } from '@wordpress/i18n';

/**
 * Get status
 * @param {boolean} confirmed
 * @param {boolean} joinable
 * @returns {JSX.Element}
 */
const CourseListItemDate = ({ start, end }) => {
	const formatter = new Intl.DateTimeFormat('fi', {
		day: 'numeric',
		month: 'numeric',
		year: 'numeric',
	});

	const startDate = start ? formatter.format(new Date(start)) : 'On Demand';
	const endDate = end ? ' - ' + formatter.format(new Date(end)) : '';

	return (
		<div className="course-list__item__content-date">
			<span>{__('Start Date & End Date', 'kotisivu-block-theme')}</span>
			<div>
				{startDate}
				{endDate}
			</div>
		</div>
	);
};

export default CourseListItemDate;
